//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').directive('datatablePagination', [
    '$rootScope',
    'StringUtils',
    function(
            $rootScope,
            StringUtils,
        ) {
      return {
        restrict: 'E',
        scope: {
          name: '@',
        },
        template: require('@legacy-components/common/datatable/datatable-pagination.html'),
        require: '^datatable',
        link(scope, element, attrs, datatable) {
          scope.model = {
            pagination: {},
          };

          scope.model.shouldHide = function() {
            return datatable.getTotalItems() === 0;
          };

          scope.model.shouldDisable = function() {
            return datatable.isLoadingOverlayDisabled() && datatable.isLoading() === true;
          };

          scope.model.pageOptions = function() {
            return datatable.getPageOptions();
          };

          scope.model.updatePage = function(page) {
            datatable.updatePage(page);
          };

          scope.model.goToFirstPage = function() {
            datatable.goToFirstPage();
          };

          scope.model.goToPreviousPage = function() {
            datatable.goToPreviousPage();
          };

          scope.model.goToNextPage = function() {
            datatable.goToNextPage();
          };

          scope.model.goToLastPage = function() {
            datatable.goToLastPage();
          };

          scope.model.changeNumPerPage = function(itemsPerPage) {
            datatable.changeNumPerPage(itemsPerPage);
          };

          $rootScope.$on(StringUtils.formatString('datatable:%s:update-pagination', scope.name), (thing, pagination) => {
            scope.model.pagination = pagination;
          });
        },
      };
    },
  ]);
})();
